import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false, error: null };

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('App error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError && this.state.error) {
            return (
                <div
                    style={{
                        padding: 24,
                        fontFamily: 'system-ui, sans-serif',
                        maxWidth: 600,
                        margin: '40px auto',
                        background: '#fef2f2',
                        border: '1px solid #fecaca',
                        borderRadius: 8,
                    }}
                >
                    <h2 style={{ color: '#b91c1c', marginTop: 0 }}>Something went wrong</h2>
                    <p style={{ color: '#991b1b' }}>{this.state.error.message}</p>
                    <pre
                        style={{
                            overflow: 'auto',
                            fontSize: 12,
                            background: '#fff',
                            padding: 12,
                            borderRadius: 4,
                        }}
                    >
                        {this.state.error.stack}
                    </pre>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
